import { RootState } from '../../store';

export const getHouseSelector = (state: RootState) => state?.houseReducer?.house;
